import { FinalImpactScoreType, NetScoreFormat } from '@upright/common/model/output/scores/types';
import {
  getAvailableAggregateMetrics,
  getDefaultAggregateMetric,
} from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { useState } from 'react';

export const useAggregateMetric = (scoreUnit: FinalImpactScoreType | undefined) => {
  const defaultFormat = getDefaultAggregateMetric(scoreUnit);

  const [userIntent, setUserIntent] = useState<NetScoreFormat>(defaultFormat);

  const availableMetrics = getAvailableAggregateMetrics(scoreUnit);

  if (!availableMetrics.includes(userIntent)) {
    return {
      aggregateMetric: defaultFormat,
      setAggregateMetric: setUserIntent,
      availableMetrics,
    };
  }

  return {
    aggregateMetric: userIntent,
    setAggregateMetric: setUserIntent,
    availableMetrics,
  };
};
